import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { NgIf } from '@angular/common';
import { ConfirmationMessageType, ConfirmationModalData } from '@shared/models/modal.model';

@Component({
  selector: 'rlst-confirmation-modal-ensemble',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [NgIf],
  templateUrl: './confirmation-modal-ensemble.component.html',
  styleUrls: ['./confirmation-modal-ensemble.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalEnsembleComponent {
  readonly ConfirmationMessageType = ConfirmationMessageType;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: ConfirmationModalData,
    private readonly dialogRef: MatDialogRef<ConfirmationModalEnsembleComponent>,
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}


